/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PermalinkViewQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly commentID: string | null;
    readonly refreshStream: boolean | null;
    readonly " $refType": "PermalinkViewQueryLocal";
};
export type PermalinkViewQueryLocal$data = PermalinkViewQueryLocal;
export type PermalinkViewQueryLocal$key = {
    readonly " $data"?: PermalinkViewQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkViewQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkViewQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'eb2cef218c3573fde888d1b0a5a1cc30';
export default node;
